import PersonCard, { Person } from './PersonCard';

interface PersonCardsProps {
  people: Person[];
}

const PersonCards = ({ people }: PersonCardsProps) => {
  if (!people) return null;
  return (
    <div className="grid grid-cols-1 gap-4 sm:gap-6 md:grid-cols-2 lg:grid-cols-3">
      {people &&
        people.map((person, idx) => (
          <PersonCard
            key={idx}
            name={person.name}
            jobTitle={person.jobTitle}
            image={person.image}
            info={person.info}
            profileLink={person.profileLink}
          />
        ))}
    </div>
  );
};

export default PersonCards;
